<template>
    <div class="grid">
        <div class="col-12">
            <div class="card text-center" v-if="permissionDenied">
                <h4>A kért oldal megtekintéséhez nincs jogosultsága!</h4>
            </div>
            <div class="card" v-if="!permissionDenied">
                <Toast/>
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button label="Új" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew"/>
                        </div>
                    </template>
                    <template v-slot:end>
                        <Button label="Export" icon="pi pi-download" class="p-button-help" @click="exportToExcel"/>
                    </template>
                </Toolbar>

                <DataTable ref="dt" :value="streets" dataKey="id"
                           :paginator="true" :rows="25" :filters="filters" :loading="loading"
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           :rowsPerPageOptions="[10,25,50,100]"
                           currentPageReportTemplate="" responsiveLayout="scroll" filterDisplay="row"
                           v-model:filters="filters"
                           :globalFilterFields="['name']">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0">Utcák <br> <strong><small>Összesen: {{ total }}</small></strong></h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global'].value" placeholder="Keresés..."/>
                            </span>
                        </div>
                    </template>

                    <Column field="id" header="#" :sortable="true" headerStyle="width:2%; min-width:5rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">#</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column field="name" header="Név" :sortable="true" headerStyle="width:50%; min-width:20rem;"
                            :showFilterMenu="false">
                        <template #body="slotProps">
                            <span class="p-column-title">Név</span>
                            {{ slotProps.data.name }}
                        </template>
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" v-model="filterModel.value" @input="filterCallback()"
                                       class="p-column-filter" :placeholder="`Keresés...`"/>
                        </template>
                    </Column>
                    <Column field="createdAt" header="Létrehozás dátuma" :sortable="true"
                            headerStyle="width:25%; min-width:20rem;">
                        <template #body="slotProps">
                            <span class="p-column-title">Létrehozás dátuma</span>
                            {{ slotProps.data.createdAt }}
                        </template>
                    </Column>
                    <Column headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                    v-tooltip.top="'Szerkesztés'" @click="edit(slotProps.data)"/>
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"
                                    v-tooltip.top="'Törlés'" @click="confirmDelete(slotProps.data)"/>
                        </template>
                    </Column>
                    <template #empty>
                        Nincs egyetlen utca sem.
                    </template>
                </DataTable>

                <Dialog v-model:visible="streetDialog" :style="{width: '600px'}" header="Utca adatai" :modal="true"
                        class="p-fluid">
                    <div class="field">
                        <label for="name">Név</label>
                        <InputText id="name" v-model.trim="street.name" required="true"
                                   :class="{'p-invalid': submitted && !street.name}"/>
                        <small class="p-invalid" v-if="submitted && !street.name">Név megadása kötelező.</small>
                    </div>

                    <template #footer>
                        <Button label="Mégse" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                        <Button label="Mentés" icon="pi pi-check" class="p-button-success" @click="saveStreet"
                                :loading="loading"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="deleteDialog" :style="{width: '450px'}" header="Megerősítés" :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span>Biztosan törölni szeretné a(z) <b>{{ street.name }}</b> utcát?</span>
                    </div>
                    <template #footer>
                        <Button label="Nem" icon="pi pi-times" class="p-button-text" @click="deleteDialog = false"/>
                        <Button label="Igen" icon="pi pi-check" class="p-button-danger" @click="deleteStreet"
                                :loading="loading"/>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import StreetService from "@/service/StreetService";
import * as dayjs from "dayjs";
import ExcelJS from 'exceljs';

export default {
    data() {
        return {
            total: 0,
            streets: null,
            streetDialog: false,
            deleteDialog: false,
            street: {},
            filters: {},
            submitted: false,
            loading: true,
            permissionDenied: true,
        }
    },
    streetService: null,
    created() {
        this.streetService = new StreetService();
        this.initFilters();
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userData'));

        if (user.role === 1) {
            this.permissionDenied = true;
        } else {
            this.permissionDenied = false;
            this.getAll()
        }
    },
    methods: {
        getAll() {
            this.streetService.getAll().then(response => {
                this.total = response.data.total
                this.streets = response.data.data
                this.loading = false;
            });
        },
        openNew() {
            this.street = {};
            this.submitted = false;
            this.streetDialog = true;
        },
        edit(street) {
            this.street = {...street};
            this.streetDialog = true;
        },
        hideDialog() {
            this.streetDialog = false;
            this.submitted = false;
        },
        confirmDelete(street) {
            this.street = {...street};
            this.deleteDialog = true;
        },
        saveStreet() {
            this.submitted = true;
            this.loading = true;

            if (this.street.name && this.street.name.trim()) {
                if (this.street.id) {
                    this.streetService.update(this.street.id, this.street).then(() => {
                        this.streetDialog = false;
                        this.street = {};
                        this.getAll();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Sikeres művelet!',
                            detail: 'Az utca módosítása sikeres volt.',
                            life: 5000
                        });

                        this.loading = false;
                    }).catch(e => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Sikertelen művelet!",
                            detail: e.response.data.error,
                            life: 6000,
                        });

                        this.loading = false;
                    });
                } else {
                    this.streetService.create(this.street).then(() => {
                        this.streetDialog = false;
                        this.street = {};
                        this.getAll();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Sikeres művelet!',
                            detail: 'Az utca mentése sikeres volt.',
                            life: 5000
                        });

                        this.loading = false;
                    }).catch(e => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Sikertelen művelet!",
                            detail: e.response.data.error,
                            life: 6000,
                        });

                        this.loading = false;
                    });
                }
            }
        },
        deleteStreet() {
            this.loading = true;

            this.streetService.delete(this.street.id).then(() => {
                this.deleteDialog = false;
                this.street = {};
                this.getAll();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sikeres művelet!',
                    detail: 'Az utca törlése sikeres volt.',
                    life: 5000
                });

                this.loading = false;
            }).catch(e => {
                this.$toast.add({
                    severity: "error",
                    summary: "Sikertelen művelet!",
                    detail: e.response.data.error,
                    life: 6000,
                });

                this.loading = false;
            });
        },
        async exportToExcel() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet 1');
            worksheet.columns = [
                { header: '#', key: 'id', width: 10 },
                { header: 'Név', key: 'name', width: 40 },
                { header: 'Létrehozás dátuma', key: 'createdAt', width: 20 }
            ];

            const data = this.streets === null ? [] : this.streets;

            data.forEach(row => {
                worksheet.addRow(Object.values(row));
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const today = dayjs().format('YYYY-MM-DD');
            const filename = `${today}_utcak.xlsx`;
            a.download = filename;
            a.click();
        },
        initFilters() {
            this.filters = {
                'global': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'name': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/badges.scss';
</style>

